import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import MyLoader from "../Spinner/MyLoader";
import "../css/Admin_css/admin-customize.css";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import MdlSelectSession from "../dialog/MdlSelectSession";

const STYLES = {
  filterCell: {
    padding: "8px 12px",
    minWidth: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  filterLabel: {
    margin: 0,
    fontSize: "11px",
    fontWeight: "800",
    color: COLORS.primary_color_shade9,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    whiteSpace: "nowrap",
    flexShrink: 0,
    padding: "4px 8px",
    borderRadius: "6px",
    background: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 1px 3px rgba(1, 87, 155, 0.15)",
  },
  sessionButton: {
    flex: 1,
    minWidth: 0,
    border: "2px solid rgba(255, 255, 255, 0.65)",
    borderRadius: "8px",
    background: "rgba(255, 255, 255, 0.22)",
    padding: "7px 10px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    textAlign: "left",
    boxShadow: "0 1px 4px rgba(1, 87, 155, 0.2)",
  },
  sessionButtonDisabled: {
    cursor: "default",
    opacity: 0.92,
  },
  sessionValue: {
    margin: 0,
    fontSize: "13px",
    fontWeight: "800",
    color: "#ffffff",
    lineHeight: "1.25",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textShadow: "0 1px 2px rgba(1, 87, 155, 0.35)",
  },
  selectOnColor: {
    flex: 1,
    minWidth: 0,
    padding: "7px 10px",
    fontSize: "13px",
    borderRadius: "8px",
    border: "2px solid rgba(255, 255, 255, 0.65)",
    background: "#ffffff",
    fontWeight: "700",
    color: COLORS.primary_color_shade9,
    outline: "none",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 1px 4px rgba(1, 87, 155, 0.2)",
  },
  classCard: {
    padding: "8px 10px",
    borderRadius: "8px",
    border: `2px solid ${COLORS.primary_color_shade3}`,
    background: COLORS.white,
    cursor: "pointer",
    transition: "all 0.2s ease",
    textAlign: "center",
    boxShadow: `0 1px 3px ${COLORS.primary_color_shade2}55`,
  },
  classCardSelected: {
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade6} 100%)`,
    border: `2px solid ${COLORS.primary_color_shade7}`,
    boxShadow: `0 3px 8px ${COLORS.primary_color_shade4}66`,
  },
  classText: {
    fontSize: "12px",
    fontWeight: "700",
    color: COLORS.primary_color_shade8,
    margin: 0,
    lineHeight: "1.25",
  },
  classTextSelected: {
    color: COLORS.white,
    fontWeight: "800",
  },
};

const FILTER_BACKGROUNDS = {
  session: `linear-gradient(135deg, ${COLORS.primary_color_shade4} 0%, ${COLORS.primary_color_shade5} 100%)`,
  board: `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade6} 100%)`,
  medium: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade7} 100%)`,
};

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

//Created By Cursor
function parseSelectedPosition(value) {
  if (value === undefined || value === null || value === "") {
    return 0;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
}

//Created By Cursor
function buildFilteredClassSectionList(data, boardId, mediumId) {
  const filtered = [];
  const matchedClasses = (data || []).filter(
    (item) => item.board_id === boardId && item.medium_id === mediumId
  );

  matchedClasses.forEach((item) => {
    if (item.section === "No") {
      filtered.push({ ...item, section_id: "No" });
      return;
    }

    (item.section || []).forEach((section) => {
      filtered.push({
        ...section,
        board_id: boardId,
        board_name: item.board_name,
        medium_id: mediumId,
        medium_name: item.medium_name,
      });
    });
  });

  return filtered;
}

//Created By Cursor
const SelectSessionClass = ({
  session_id,
  session_name,
  session_status,
  start_date,
  end_date,
  sessionChangePermission,
  selected_position,
  initial_class_id,
  initial_section_id,
  action,
  onSessionChange,
}) => {
  const sltBoardRef = useRef(null);
  const sltMediumRef = useRef(null);

  const canChangeSession = sessionChangePermission !== false;

  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [classBoard, setClassBoard] = useState([]);
  const [classMedium, setClassMedium] = useState([]);
  const [mClassData, setMClassData] = useState([]);
  const [mFilteredClassSectionList, setFilteredClassSectionList] = useState(
    []
  );
  const [classSelectedPosition, setClassSelectedPosition] = useState(
    parseSelectedPosition(selected_position)
  );
  const [sessionId, setSessionId] = useState(session_id || "");
  const [sessionName, setSessionName] = useState(session_name || "");
  const [sessionStatus, setSessionStatus] = useState(session_status || "");
  const [startDate, setStartDate] = useState(start_date || "");
  const [endDate, setEndDate] = useState(end_date || "");
  const loadedSessionRef = useRef("");

  //Created By Cursor
  const notifySelection = useCallback(
    (filtered, position, currentSessionId, currentSessionName) => {
      if (
        typeof action !== "function" ||
        !filtered.length ||
        position < 0 ||
        position >= filtered.length
      ) {
        return;
      }

      const item = filtered[position];
      const effectiveSessionId =
        item.session_id || currentSessionId || sessionId || "";

      action(
        item.class_id,
        item.section_id,
        effectiveSessionId,
        position,
        item.class_name,
        item.section_name,
        currentSessionName || sessionName || "",
        item.board_id,
        item.medium_id
      );
    },
    [action, sessionId, sessionName]
  );

  //Created By Cursor
  const resolvePosition = useCallback(
    (filtered, preferredPosition) => {
      let nextPosition = parseSelectedPosition(preferredPosition);
      if (nextPosition < 0 || nextPosition >= filtered.length) {
        nextPosition = 0;
      }

      if (initial_class_id != null && initial_section_id != null) {
        const idx = filtered.findIndex(
          (s) =>
            String(s.class_id) === String(initial_class_id) &&
            String(s.section_id) === String(initial_section_id)
        );
        if (idx >= 0) nextPosition = idx;
      }

      return nextPosition;
    },
    [initial_class_id, initial_section_id]
  );

  //Created By Cursor
  const applyFilteredList = useCallback(
    (
      data,
      currentSessionId,
      currentSessionName,
      preferredPosition = classSelectedPosition
    ) => {
      if (!sltBoardRef.current || !sltMediumRef.current) {
        return;
      }

      const boardId =
        sltBoardRef.current.selectedOptions[0]?.getAttribute("board_id");
      const mediumId =
        sltMediumRef.current.selectedOptions[0]?.getAttribute("medium_id");

      if (!boardId || !mediumId) {
        setFilteredClassSectionList([]);
        return;
      }

      const filtered = buildFilteredClassSectionList(data, boardId, mediumId);
      const nextPosition = resolvePosition(filtered, preferredPosition);
      setFilteredClassSectionList(filtered);
      setClassSelectedPosition(nextPosition);
      notifySelection(
        filtered,
        nextPosition,
        currentSessionId,
        currentSessionName
      );
    },
    [classSelectedPosition, notifySelection, resolvePosition]
  );

  //Created By Cursor
  const loadClasses = useCallback(
    (currentSessionId, currentSessionName, preferredPosition) => {
      if (!currentSessionId) return;

      setLoading(true);
      const schoolCode = SessionManager.getSchoolCode();

      axios
        .get(`${API_BASE()}getClass.php`, {
          params: {
            school_code: schoolCode,
            session_id: currentSessionId,
          },
        })
        .then((res) => res.data)
        .then((response) => {
          setLoading(false);
          if (response.api_status === "OK") {
            const classData = response.data.class || [];
            const boards = response.data.board || [];
            const mediums = response.data.medium || [];
            setMClassData(classData);
            setClassBoard(boards);
            setClassMedium(mediums);
            // Defer so board/medium selects exist after this render.
            setTimeout(() => {
              applyFilteredList(
                classData,
                currentSessionId,
                currentSessionName,
                preferredPosition
              );
            }, 0);
          } else {
            myToast.notify_warning(response.api_remark);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("[SelectSessionClass] getClass error:", error);
          myToast.notify_error("Failed to load class data.");
        });
    },
    [applyFilteredList]
  );

  useEffect(() => {
    let nextSessionId = session_id || "";
    let nextSessionName = session_name || "";
    let nextSessionStatus = session_status || "";
    let nextStartDate = start_date || "";
    let nextEndDate = end_date || "";

    if (!nextSessionId) {
      const mSession = SessionManager.getCurrentSession();
      if (mSession?.[0]) {
        nextSessionId = mSession[0].session_id || "";
        nextSessionName = mSession[0].session_name || "";
        nextSessionStatus = mSession[0].status || "";
        nextStartDate = mSession[0].start_date || "";
        nextEndDate = mSession[0].end_date || "";
      }
    }

    setSessionId(nextSessionId);
    setSessionName(nextSessionName);
    setSessionStatus(nextSessionStatus);
    setStartDate(nextStartDate);
    setEndDate(nextEndDate);

    // Skip reload if this session was already loaded (e.g. after local picker + parent sync)
    if (
      nextSessionId &&
      String(loadedSessionRef.current) === String(nextSessionId)
    ) {
      return;
    }

    setClassSelectedPosition(parseSelectedPosition(selected_position));
    loadedSessionRef.current = nextSessionId || "";
    loadClasses(
      nextSessionId,
      nextSessionName,
      parseSelectedPosition(selected_position)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- remount / parent session id change
  }, [session_id]);

  //Created By Cursor — keep label in sync when parent updates name for same session
  useEffect(() => {
    if (session_name != null && session_name !== "") {
      setSessionName(session_name);
    }
    if (session_status != null && session_status !== "") {
      setSessionStatus(session_status);
    }
  }, [session_name, session_status]);

  // Keep selection snapped when URL-driven class/section changes after data is ready.
  useEffect(() => {
    if (!mClassData.length) return;
    applyFilteredList(
      mClassData,
      sessionId,
      sessionName,
      classSelectedPosition
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initial_class_id, initial_section_id]);

  //Created By Cursor
  const handleSelectedSession = (
    nextSessionId,
    nextSessionName,
    nextSessionStatus,
    nextStartDate,
    nextEndDate
  ) => {
    const name = nextSessionName || "";
    setSessionId(nextSessionId);
    setSessionName(name);
    setSessionStatus(nextSessionStatus || "");
    setStartDate(nextStartDate || "");
    setEndDate(nextEndDate || "");
    setIsOpenSessionDialog(false);
    setClassSelectedPosition(0);

    // Persist so other screens (and remounts) see the new session
    try {
      SessionManager.saveCurrentSession([
        {
          session_id: nextSessionId,
          session_name: name,
          status: nextSessionStatus || "",
          start_date: nextStartDate || "",
          end_date: nextEndDate || "",
        },
      ]);
    } catch (e) {
      console.warn("[SelectSessionClass] saveCurrentSession failed", e);
    }

    if (typeof onSessionChange === "function") {
      onSessionChange(
        nextSessionId,
        name,
        nextSessionStatus || "",
        nextStartDate || "",
        nextEndDate || ""
      );
    }

    loadedSessionRef.current = nextSessionId || "";
    loadClasses(nextSessionId, name, 0);
  };

  //Created By Cursor
  const handleBoardMediumChange = () => {
    setClassSelectedPosition(0);
    applyFilteredList(mClassData, sessionId, sessionName, 0);
  };

  //Created By Cursor
  const selectClass = (position) => {
    setClassSelectedPosition(position);
    notifySelection(
      mFilteredClassSectionList,
      position,
      sessionId,
      sessionName
    );
  };

  //Created By Cursor
  const openSessionDialog = () => {
    if (!canChangeSession) return;
    setIsOpenSessionDialog(true);
  };

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <div style={{ position: "relative" }}>
      {loading ? (
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(255,255,255,0.72)",
            borderRadius: 10,
          }}
        >
          <MyLoader />
        </div>
      ) : null}
      <div
        style={{
          background: COLORS.white,
          borderRadius: "10px",
          padding: "0",
          boxShadow: `0 4px 14px ${COLORS.primary_color_shade3}55`,
          border: `2px solid ${COLORS.primary_color_shade3}`,
          overflow: "hidden",
          opacity: loading ? 0.85 : 1,
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "minmax(200px, 1.1fr) minmax(180px, 1fr) minmax(180px, 1fr)",
            alignItems: "stretch",
            borderBottom: `2px solid ${COLORS.primary_color_shade3}`,
          }}
        >
          <div
            style={{
              ...STYLES.filterCell,
              background: FILTER_BACKGROUNDS.session,
            }}
          >
            <p style={STYLES.filterLabel}>
              <i
                className="fa fa-calendar"
                aria-hidden="true"
                style={{ color: COLORS.primary_color_shade6 }}
              />
              Session
            </p>
            <button
              type="button"
              style={{
                ...STYLES.sessionButton,
                ...(canChangeSession ? {} : STYLES.sessionButtonDisabled),
              }}
              onClick={openSessionDialog}
              disabled={!canChangeSession}
              onMouseEnter={(e) => {
                if (!canChangeSession) return;
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.32)";
                e.currentTarget.style.borderColor = "#ffffff";
              }}
              onMouseLeave={(e) => {
                if (!canChangeSession) return;
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.22)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.65)";
              }}
            >
              <p style={STYLES.sessionValue}>
                {sessionName || "Select"}
                {sessionStatus ? ` (${sessionStatus})` : ""}
              </p>
              {canChangeSession ? (
                <i
                  className="fa fa-chevron-down"
                  aria-hidden="true"
                  style={{ color: "#fff", fontSize: "13px", flexShrink: 0 }}
                />
              ) : null}
            </button>
          </div>

          <div
            style={{
              ...STYLES.filterCell,
              background: FILTER_BACKGROUNDS.board,
              borderLeft: "2px solid rgba(255, 255, 255, 0.35)",
            }}
          >
            <label style={STYLES.filterLabel} htmlFor="ssc-board-select">
              <i
                className="fa fa-graduation-cap"
                aria-hidden="true"
                style={{ color: COLORS.primary_color_shade6 }}
              />
              Board
            </label>
            <select
              id="ssc-board-select"
              style={STYLES.selectOnColor}
              onChange={handleBoardMediumChange}
              ref={sltBoardRef}
              onFocus={(e) => {
                e.target.style.borderColor = "#ffffff";
                e.target.style.boxShadow = "0 0 0 3px rgba(255, 255, 255, 0.25)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "rgba(255, 255, 255, 0.65)";
                e.target.style.boxShadow = "0 1px 4px rgba(1, 87, 155, 0.2)";
              }}
            >
              {classBoard.map((item) => (
                <option key={item.board_id} board_id={item.board_id}>
                  {item.board_name}
                </option>
              ))}
            </select>
          </div>

          <div
            style={{
              ...STYLES.filterCell,
              background: FILTER_BACKGROUNDS.medium,
              borderLeft: "2px solid rgba(255, 255, 255, 0.35)",
            }}
          >
            <label style={STYLES.filterLabel} htmlFor="ssc-medium-select">
              <i
                className="fa fa-book"
                aria-hidden="true"
                style={{ color: COLORS.primary_color_shade6 }}
              />
              Medium
            </label>
            <select
              id="ssc-medium-select"
              style={STYLES.selectOnColor}
              onChange={handleBoardMediumChange}
              ref={sltMediumRef}
              onFocus={(e) => {
                e.target.style.borderColor = "#ffffff";
                e.target.style.boxShadow = "0 0 0 3px rgba(255, 255, 255, 0.25)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "rgba(255, 255, 255, 0.65)";
                e.target.style.boxShadow = "0 1px 4px rgba(1, 87, 155, 0.2)";
              }}
            >
              {classMedium.map((item) => (
                <option key={item.medium_id} medium_id={item.medium_id}>
                  {item.medium_name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {mFilteredClassSectionList.length > 0 ? (
          <div
            style={{
              background: COLORS.white,
              padding: "8px 12px",
              borderTop: `2px solid ${COLORS.primary_color_shade2}`,
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(96px, 1fr))",
                gap: "6px",
              }}
            >
              {mFilteredClassSectionList.map((item, index) => {
                const isSelected = classSelectedPosition === index;
                const label =
                  item.section === "No" || item.section_id === "No"
                    ? item.class_name
                    : `${item.class_name}:${item.section_name}`;

                return (
                  <div
                    key={`${item.class_id}-${item.section_id}-${index}`}
                    role="button"
                    tabIndex={0}
                    style={{
                      ...STYLES.classCard,
                      ...(isSelected ? STYLES.classCardSelected : {}),
                    }}
                    onClick={() => selectClass(index)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        selectClass(index);
                      }
                    }}
                    onMouseEnter={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.background =
                          COLORS.primary_color_shade1;
                        e.currentTarget.style.borderColor =
                          COLORS.primary_color_shade5;
                        e.currentTarget.style.boxShadow = `0 2px 6px ${COLORS.primary_color_shade3}55`;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.background = COLORS.white;
                        e.currentTarget.style.borderColor =
                          COLORS.primary_color_shade3;
                        e.currentTarget.style.boxShadow = `0 1px 3px ${COLORS.primary_color_shade2}55`;
                      }
                    }}
                  >
                    <p
                      style={{
                        ...STYLES.classText,
                        ...(isSelected ? STYLES.classTextSelected : {}),
                      }}
                    >
                      {label}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>

      {isOpenSessionDialog ? (
        <MdlSelectSession
          action={() => setIsOpenSessionDialog(false)}
          action2={handleSelectedSession}
        />
      ) : null}
    </div>
  );
};

export default SelectSessionClass;
